<!--
  核销员列表
-->
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">配置管理</el-breadcrumb-item>
      <el-breadcrumb-item>火花设置</el-breadcrumb-item>
    </el-breadcrumb>
    <el-container>
      <el-main>


        <!--列表-->
        <el-table size="small" ref="tabs" :header-cell-style="{background:'#eef1f6',color:'#606266'}":data="listData"
                  highlight-current-row v-loading="loading" border
                  element-loading-text="拼命加载中" style="width: 100%;"
                  :row-key="(row) => { return row.id }">


          <el-table-column prop="id" label="id" align="center"></el-table-column>
          <el-table-column prop="browseNum" label="浏览量" align="center"></el-table-column>
          <el-table-column prop="commentNum" label="评论量" align="center"></el-table-column>
          <el-table-column prop="likeNum" label="点赞量" align="center"></el-table-column>


          <el-table-column  label="操作" align="left" fixed="right">
            <template slot-scope="scope">
              <el-button size="mini" type="success" @click="handleEdit(scope.row)"style="width: 100px;margin: 1px;">编辑</el-button>
            </template>
          </el-table-column>

        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>




        <!-- 编辑界面 -->
        <el-dialog :title="title" :visible.sync="editFormVisible" width="60%" @click='closeDialog("edit")':close-on-click-modal="false">
          <el-form label-width="150px" :model="editForm" ref="editForm"  :rules="rules">


            <el-form-item label="浏览量" prop="browseNum">
              <el-input-number :min="0" oninput="if (value < 0) value= null" placeholder="浏览量" v-model="editForm.browseNum" style="width: 250px"></el-input-number>
            </el-form-item>
            <el-form-item label="评论量" prop="commentNum">
              <el-input-number :min="0" oninput="if (value < 0) value= null" placeholder="评论量" v-model="editForm.commentNum" style="width: 250px"></el-input-number>
            </el-form-item>
            <el-form-item label="点赞量" prop="likeNum">
              <el-input-number :min="0" oninput="if (value < 0) value= null" placeholder="点赞量" v-model="editForm.likeNum" style="width: 250px"></el-input-number>
            </el-form-item>

          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click='closeDialog("edit")'>取消</el-button>
            <el-button size="small" type="primary" class="title" :loading="loading" :disabled="isDisabled" @click="submitForm('editForm')">保存</el-button>
          </div>
        </el-dialog>




      </el-main>
    </el-container>
  </div>
</template>

<script>


import {qryParamHuo, upParamHuo} from '../../api/dom'
import {timestampToTime,parseTime} from "../../utils/util";
import Pagination from '../../components/Pagination'
import ElInputNumber from "../../../node_modules/element-ui/packages/input-number/src/input-number.vue";
import wangeditor from "../../components/wangeditor";

export default {
  name: "userList",

  data() {
    return {
      title:'修改',
      editFormVisible:false,
      loading: false, //是显示加载
      isDisabled: false,
      formInline:{
        page:1,
        pageSize:10
      },
      listData:[],
      multipleSelection:[],
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      editForm:{
        id:'',
        browseNum:'',
        commentNum:'',
        likeNum:'',
      },
      rules: {
        browseNum: [
          { required: true, message: '必填字段不能为空', trigger: 'blur' }
        ],
        commentNum: [
          { required: true, message: '必填字段不能为空', trigger: 'blur' }
        ],
        likeNum: [
          { required: true, message: '必填字段不能为空', trigger: 'blur' }
        ],
      },

    }
  },
  mounted() {
    this.tableList();
  },
  methods:{
    tableList(e){
      if (e == 1){
        this.formInline.page = 1
      }
      this.loading = true;
      qryParamHuo(this.formInline).then(res => {
        this.listData = res.data.list;
        this.pageparm.currentPage = this.formInline.page;
        this.pageparm.pageSize = this.formInline.pageSize;
        this.pageparm.total = res.data.total;
        this.loading = false
      })
    },



    resetFrom(){
      this.formInline.page = 1;
      this.formInline.pageSize = 10;
    },


    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage;
      this.formInline.pageSize = parm.pageSize;
      this.tableList();
    },



    //显示编辑界面
    handleEdit: function(row) {
      if (row != undefined && row != 'undefined') {
        this.title = '修改'
        this.editForm.id = row.id
        this.editForm.likeNum = row.likeNum
        this.editForm.commentNum = row.commentNum
        this.editForm.browseNum = row.browseNum

        this.editFormVisible = true
      } else {
        this.title = '添加'
        this.editFormVisible = true
        this.clear()
      }
    },

    clear(){
      this.editForm.id = ''
      this.editForm.likeNum = '';
      this.editForm.commentNum = ''
      this.editForm.browseNum = ''
    },





    closeDialog(editData){
      this.$refs['editForm'].resetFields();
      this.editFormVisible = false;
      this.clear();
    },



    // 编辑、添加提交方法
    submitForm(editData) {
      this.isDisabled = true;
      this.$refs[editData].validate(valid => {
        if (valid) {
          if(this.editForm.id!=''){
            upParamHuo(this.editForm).then(res =>{
              if (res.code==1) {
                this.editFormVisible = false
                this.$message({
                  type: 'success',
                  message: '数据保存成功！'
                })
                this.tableList()
                this.clear()
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
              this.isDisabled = false;
            }).catch(err => {
              this.editFormVisible = false
              this.$message.error('保存失败，请稍后再试！')
              this.isDisabled = false;
            })
          }
          else{
            upParamHuo(this.editForm)
              .then(res => {
                if (res.code==1) {
                  this.editFormVisible = false
                  this.$message({
                    type: 'success',
                    message: '数据保存成功！'
                  })
                  this.tableList(this.formInline)
                  this.clear()
                } else {
                  this.$message({
                    type: 'info',
                    message: res.msg
                  })
                }
                this.isDisabled = false;
              })
              .catch(err => {
                this.editFormVisible = false
                this.$message.error('保存失败，请稍后再试！')
                this.isDisabled = false;
              })
          }
          // 请求方法
        } else {
          this.isDisabled = false;
          return false
        }
      })
    },



  },
  //分页组件
  components: {
    ElInputNumber,
    wangeditor,
    Pagination
  }
}



</script>



<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/pz/huo.vue